var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoctorPrimaryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doctorPrimaryIcon_svg__clip0_3734_45025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.248 27.124s-1.992-7.642-2.573-8.846c-.3-.622-2.19-1.62-4.232-2.441.049.847.026 1.69-.063 2.49-.039.354-.09.7-.153 1.036.31.059.611.152.893.281.87.399 1.544 1.125 1.704 2.182.124.828-.14 2.55-.258 3.241a1.446 1.446 0 11-.953-.094c.104-.6.373-2.276.263-3.004-.105-.7-.562-1.185-1.153-1.456a3.092 3.092 0 00-1.277-.264c-.449 0-.893.088-1.277.264-.59.271-1.048.757-1.154 1.456-.11.729.16 2.405.264 3.004a1.447 1.447 0 11-.953.094c-.117-.691-.383-2.413-.258-3.24.16-1.057.834-1.785 1.704-2.183a4.008 4.008 0 011.492-.35c.068-.346.123-.703.164-1.072.098-.88.111-1.822.026-2.764a29.674 29.674 0 00-1.06-.365c1.523-.86 2.692-2.458 2.895-4.796h.395c.21 0 .359-.174.382-.384l.25-2.168c.024-.21-.173-.382-.383-.382h-.613V3.91c0-4.562-11.643-4.562-11.643 0v3.453h-.612c-.211 0-.408.174-.384.382l.25 2.168c.024.21.172.384.383.384h.395c.204 2.338 1.371 3.936 2.895 4.796-.37.12-.753.251-1.138.393a13.764 13.764 0 00.185 3.768c.133.69.32 1.333.55 1.917a1.447 1.447 0 11-.974.133 12.04 12.04 0 01-.516-1.87c-.217-1.12-.3-2.344-.232-3.567-2.012.814-3.86 1.796-4.156 2.41C2.743 19.481.75 27.123.75 27.123c5.271 4.536 18.225 4.536 23.497 0l.001.001zM16.921 9.56V7.176H8.079V9.56c0 1.373.375 2.731 1.388 3.703.812.78 1.913 1.181 3.032 1.181 1.12 0 2.22-.401 3.033-1.18 1.013-.973 1.388-2.332 1.388-3.704zm-8.023 12.43a.599.599 0 100 1.198.599.599 0 000-1.198zm10.057 3.793a.599.599 0 11.001 1.197.599.599 0 010-1.197zm-5.018 0a.598.598 0 100 1.195.598.598 0 000-1.195z",
    fill: "url(#doctorPrimaryIcon_svg__paint0_linear_3734_45025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "doctorPrimaryIcon_svg__paint0_linear_3734_45025",
    x1: 13.881,
    y1: 56.899,
    x2: 34.162,
    y2: 49.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "doctorPrimaryIcon_svg__clip0_3734_45025"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v31.385H0z"
  })))));
}

export default SvgDoctorPrimaryIcon;